import { render, staticRenderFns } from "./AccepterTopMenu.vue?vue&type=template&id=576cf371&"
import script from "./AccepterTopMenu.vue?vue&type=script&lang=ts&"
export * from "./AccepterTopMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports